import { createApp } from 'vue';
import Vuelidate from '@vuelidate/core';
import VueScrollTo from 'vue-scrollto';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { createGtm } from '@gtm-support/vue-gtm';
import ScriptX from 'vue-scriptx';
import Ads from 'vue-google-adsense';
// import VCalendar from 'v-calendar';
import App from './App.vue';
import axios from './plugins/axios';
// import './registerServiceWorker';
import router from './router';
import store from './store';

const app = createApp(App);
app.config.globalProperties.axios = axios;
app.use(store);
app.use(router);
app.use(Vuelidate);
app.use(VueScrollTo);
app.use(createGtm({
  // see https://www.npmjs.com/package/@gtm-support/vue-gtm
  id: 'GTM-TTZ4T4Q',
  vueRouter: router,
}));
app.use(ScriptX);
app.use(Ads.Adsense);
app.use(Ads.InArticleAdsense);
app.use(Ads.InFeedAdsense);
// app.use(VCalendar, {});
app.mount('#app');
